import dateParser from '@/utils/dateParser';
import { useLocales } from '@/locales';
import getLangStorage from '@/utils/getLangStorage';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export default function ScrollDialog({
  open,
  handleClose,
  notifications,
  handleDisableAllNotifications,
}) {
  const { translate } = useLocales();
  return (
    <Dialog open={open} onOpenChange={isOpen => !isOpen && handleClose()}>
      <DialogContent className="header-notification sm:max-w-lg max-h-[80vh] flex flex-col">
        <DialogHeader className="header-notification__header">
          <DialogTitle>{translate('Notifications')}</DialogTitle>
          <button
            type="button"
            onClick={handleClose}
            className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </button>
        </DialogHeader>
        <div className="header-notification__content flex-1 overflow-y-auto divide-y">
          {notifications.length ? (
            notifications.map((noti, index) => (
              <div className="header-notification__modal py-3" key={index}>
                <div
                  className={`header-notification__modal--list ${noti.status}`}
                >
                  <div className="modal-list__infos">
                    <h4 className="modal-list__infos--name">
                      {translate('Application')} : {noti.header}
                    </h4>
                    <h4 className="modal-list__infos--date text-disabled">
                      {dateParser(noti.createdAt)}
                    </h4>
                  </div>
                  <div className="header-notification__modal--content">
                    <p className="subtitle text-disabled">
                      {noti[getLangStorage('i18nextLng')]
                        ? noti[getLangStorage('i18nextLng')].message
                        : null}
                    </p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <h4 className="subtitle text-center py-4">
              {translate('Notifications_yet')}
            </h4>
          )}
        </div>
        <DialogFooter className="header-notification__options">
          <Button
            onClick={handleDisableAllNotifications}
            className="app-button header-notification__options--button"
          >
            {translate('Clear_notify')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
